import React, { useState, useEffect, useRef, useMemo } from 'react';
import LotteryForm from './LotteryForm';
import TopNavbar from './TopNavbar';
import './LotteryActivityManager.css';
// 导入默认图片
import themeImage from '../images/theme.png';
import defaultBackgroundImage from '../images/background.png';
import dividingLineImage from '../images/dividing_line.png';
import pointerImage from '../images/pointer.png';
import rouletteImage from '../images/roulette .png';

const LotteryActivityManager = () => {
  const [activeTab, setActiveTab] = useState('homepage');
  const [activeSubTab, setActiveSubTab] = useState('basic'); // 'basic' | 'distribution' | 'awards' | 'advanced'
  const [isPublished, setIsPublished] = useState(false);
  const [participantCount, setParticipantCount] = useState(0);
  const [activePrizeIndex, setActivePrizeIndex] = useState(0); // 当前选中的奖品索引
  const [prizeTabsStartIndex, setPrizeTabsStartIndex] = useState(0); // 奖项标签导航显示的起始索引
  const prizeTabsRef = useRef(null); // 奖项标签导航的ref
  const wheelImageRef = useRef(null);
  const [wechatShare, setWechatShare] = useState({
    title: '参与活动赢大奖',
    desc: '点击"开始"转盘开始转动,最终指针指着的即为您所中的奖品。',
    img: ''
  });
  const [showWechatModal, setShowWechatModal] = useState(false);
  const [isDraggingTheme, setIsDraggingTheme] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [previewRef, setPreviewRef] = useState(null);
  const [wheelImageSize, setWheelImageSize] = useState(0);
  const [activityConfig, setActivityConfig] = useState({
    // 基础设置
    title: '参与活动赢大奖',
    description: '点击"开始"转盘开始转动,最终指针指着的即为您所中的奖品。',
    startTime: '2025-10-21 18:21',
    endTime: '2025-10-28 18:21',
    platform: 'wechat', // wechat, douyin, embed, facebook
    timeLimit: false,
    descriptionType: 'text', // text, detailed, rich
    
    // 参与条件
    enterpriseWechatOnly: false,
    participantLimit: 'unlimited', // unlimited, limit
    maxParticipants: 50,
    fanExclusive: false,
    regionLimit: 'all', // all, some, specific
    
    // 奖品设置
    prizes: [
      { 
        id: 0,
        level: '谢谢参与', 
        name: '谢谢参与', 
        type: 'selfSelected',
        subType: 'physicalGift',
        probability: 25, 
        color: '#DDA0DD', 
        icon: '🍀', 
        coupon: null, 
        quantity: 0,
        image: '', // 奖品图片
        description: '',
        repeatWinLimit: 'unlimited', // 'unlimited' | 'enabled'
        introduction: 'hide', // 'hide' | 'show'
        introductionText: '',
        payToRedeem: 'close', // 'close' | 'enable'
        redeemMethod: 'pickup', // 'pickup' | 'mail'
        isCommon: false,
        isConsolation: false,
        isEmptyPrize: true // 标记为空奖
      },
      { 
        id: 1,
        level: '一等奖', 
        name: '价值5元小礼品 (示例)', 
        type: 'selfSelected', // 'selfSelected' | 'cardRecharge' | 'takeoutRedPacket' | 'ownGift' | 'mallGift' | 'storeGift'
        subType: 'physicalGift', // 自选奖品的子类型
        probability: 5, 
        color: '#FF6B6B', 
        icon: '🎁', 
        coupon: 'PRIZE_001', 
        quantity: 1,
        image: '', // 奖品图片
        description: '',
        repeatWinLimit: 'unlimited', // 'unlimited' | 'enabled'
        introduction: 'hide', // 'hide' | 'show'
        introductionText: '',
        payToRedeem: 'close', // 'close' | 'enable'
        redeemMethod: 'pickup', // 'pickup' | 'mail'
        isCommon: false,
        isConsolation: false
      },
      { 
        id: 2,
        level: '二等奖', 
        name: '二等奖', 
        type: 'selfSelected',
        subType: 'physicalGift',
        probability: 15, 
        color: '#4ECDC4', 
        icon: '🎁', 
        coupon: 'PRIZE_002', 
        quantity: 3,
        image: '',
        description: '',
        repeatWinLimit: 'unlimited',
        introduction: 'hide',
        introductionText: '',
        payToRedeem: 'close',
        redeemMethod: 'pickup',
        isCommon: false,
        isConsolation: false
      },
      { 
        id: 3,
        level: '三等奖', 
        name: '三等奖', 
        type: 'selfSelected',
        subType: 'physicalGift',
        probability: 30, 
        color: '#45B7D1', 
        icon: '🎁', 
        coupon: 'PRIZE_003', 
        quantity: 10,
        image: '',
        description: '',
        repeatWinLimit: 'unlimited',
        introduction: 'hide',
        introductionText: '',
        payToRedeem: 'close',
        redeemMethod: 'pickup',
        isCommon: false,
        isConsolation: false
      },
      { 
        id: 4,
        level: '安慰奖', 
        name: '安慰奖', 
        type: 'selfSelected',
        subType: 'physicalGift',
        probability: 25, 
        color: '#96CEB4', 
        icon: '🎁', 
        coupon: 'CONSOLATION_001', 
        quantity: 20,
        image: '',
        description: '',
        repeatWinLimit: 'unlimited',
        introduction: 'hide',
        introductionText: '',
        payToRedeem: 'close',
        redeemMethod: 'pickup',
        isCommon: false,
        isConsolation: true
      }
    ],
    hideThankYouPrize: false,
    
    // 抽奖设置
    dailyDrawLimit: 3,
    totalDrawLimit: 'unlimited',
    
    // 派奖方式配置
    distributionMethod: {
      // 抽奖限制
      totalDrawChances: 'unlimited', // 'unlimited' | 'limited'
      totalDrawLimit: 0, // 总抽奖机会限制数量
      dailyDrawChances: 'limited', // 'unlimited' | 'limited'
      dailyDrawLimit: 3, // 每日抽奖机会限制数量
      
      // 中奖率
      maxWinPerPerson: 1, // 每人最多中奖次数
      dailyWinLimit: 'unlimited', // 'unlimited' | 'limited'
      dailyWinLimitCount: 0, // 每日中奖次数限制
      drawMode: 'traffic', // 'traffic' | 'time' - 按人流量发放 | 时间均匀发放
      totalWinRate: 10, // 总中奖率 (%)
      prizeDistribution: 'off', // 'off' | '12h' | '24h' | '48h' - 奖品分期投放
      
      // 获得额外机会
      extraChances: [] // 额外机会配置列表
    },
    
    // 主题设置
    theme: {
      primaryColor: '#FF6B6B',
      secondaryColor: '#FFE66D',
      backgroundColor: '#FFF5F5',
      textColor: '#333333'
    },
    
    // 背景设置
    background: {
      type: 'color', // 'color' | 'image' | 'gradient'
      color: '#FFF5F5',
      image: '',
      gradient: 'linear-gradient(135deg, #FF6B6B, #FFE66D)'
    },
    
    // 抽奖主题设置
    lotteryTheme: {
      titleImage: themeImage, // 抽奖主题图片
      titlePosition: { x: 0, y: 0 } // 主题图片位置 (可拖动)
    },
    
    // 背景图片设置
    backgroundImage: {
      image: defaultBackgroundImage, // 背景图片
      show: true // 是否显示背景图片
    },
    
    // 转盘设置
    wheel: {
      wheelImage: rouletteImage, // 转盘图片
      dividerLine: dividingLineImage, // 分割线图片
      pointer: '', // 指针图片 - 已移除
      startButton: pointerImage // 开始按钮图片 - 默认为指针图片
    }
  });

  // 将"谢谢参与"也作为奖品，判断时不进行排除
  const totalPrizeCount = activityConfig.prizes.length; // 总奖品数量（包括谢谢参与）
  const regularPrizes = activityConfig.prizes.filter((prize, index) => !(index === 0 || prize.isEmptyPrize));
  
  // 当奖品总数 > 2 时，可以选择开启隐藏掉"谢谢参与"
  // 其余情况（<= 2）则为关闭（不隐藏谢谢参与）
  const canHideThankYouPrize = totalPrizeCount > 2; // 总数 > 2 时可以选择
  const shouldAutoClose = totalPrizeCount <= 2; // 总数 <= 2 时自动关闭（显示谢谢参与）
  
  // 当开启隐藏且总数 > 2 时，使用排除谢谢参与的奖品列表，否则使用全部奖品
  const wheelPrizes = activityConfig.hideThankYouPrize && canHideThankYouPrize && regularPrizes.length > 0 
    ? regularPrizes 
    : activityConfig.prizes;

  const displayWheelPrizes = useMemo(() => {
    if (wheelPrizes.length === 2) {
      return wheelPrizes.flatMap((prize, idx) => [
        { ...prize, _duplicateId: `${prize.id || idx}-dup-a` },
        { ...prize, _duplicateId: `${prize.id || idx}-dup-b` }
      ]);
    }
    return wheelPrizes;
  }, [wheelPrizes]);
  
  useEffect(() => {
    const img = wheelImageRef.current;
    if (!img) {
      setWheelImageSize(0);
      return;
    }

    const updateSize = () => {
      setWheelImageSize(img.offsetWidth || img.naturalWidth || 0);
    };

    if (img.complete) {
      updateSize();
    } else {
      img.addEventListener('load', updateSize);
    }

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(updateSize);
      observer.observe(img);
      return () => {
        img.removeEventListener('load', updateSize);
        observer.disconnect();
      };
    }

    return () => {
      img.removeEventListener('load', updateSize);
    };
  }, [activityConfig.wheel.wheelImage]);

  const renderDividerLines = (size) => {
    const effectiveSize = size || 280;
    if (!displayWheelPrizes.length) return null;
    const total = displayWheelPrizes.length;
    const radius = effectiveSize / 2;
    const lineLength = radius * 0.92;
    const dividerSrc = activityConfig.wheel.dividerLine || dividingLineImage;

    return displayWheelPrizes.map((prize, index) => {
      const segmentAngle = 360 / total;
      // 第一条分割线作为参考物，在12点钟方向（180度）
      // 第一条分割线：180度
      // 第二条分割线：180 + segmentAngle
      // 第三条分割线：180 + 2 * segmentAngle
      // 以此类推...
      const firstDividerAngle = 180; // 第一条分割线的角度（12点钟方向）
      const angle = firstDividerAngle + segmentAngle * index; // 每条分割线的角度
      console.log(`分割线 ${index + 1}: segmentAngle=${segmentAngle.toFixed(2)}°, angle=${angle.toFixed(2)}°`);
      return (
        <div
          key={`divider-${prize._duplicateId || prize.id || index}`}
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: dividerSrc ? 'auto' : '2px',
            height: `${lineLength}px`,
            transformOrigin: 'center top',
            transform: `translate(-50%, 0) rotate(${angle}deg)`,
            zIndex: 2,
            pointerEvents: 'none'
          }}
        >
          {dividerSrc ? (
            <img
              src={dividerSrc}
              alt="分割线"
              style={{ width: 'auto', height: '100%', display: 'block' }}
            />
          ) : (
            <div style={{ width: '2px', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.6)' }} />
          )}
        </div>
      );
    });
  };
  
  const renderPrizeOverlayElements = (size) => {
    const effectiveSize = size || 280;
    if (!displayWheelPrizes.length) return null;
    const total = displayWheelPrizes.length;
    const radius = effectiveSize / 2;
    const overlayRadius = radius * 0.74;
    const imageSize = Math.max(28, Math.min(50, effectiveSize * 0.19));
    const fontSize = Math.max(10, Math.min(13, effectiveSize * 0.04));
    
    return displayWheelPrizes.map((prize, index) => {
      const segmentAngle = 360 / total; // 每个扇区的夹角度数
      // 根据奖品数量的奇偶性计算第一个奖品角度
      // 由于180度是12点钟方向，那么：
      // - 180度 = 12点钟方向（顶部）
      // - 0度 = 6点钟方向（底部）
      // 奇数：第一个奖品角度 = 6点钟方向（0度）
      // 偶数：第一个奖品角度 = 6点钟方向 + (360/奖品数)/2 = 0 + segmentAngle/2
      const sixOClockAngle = 90; // 6点钟方向（底部）- 如果180度是12点钟方向
      const firstPrizeAngle = total % 2 === 1 
        ? sixOClockAngle  // 奇数：6点钟方向（0度）
        : sixOClockAngle + segmentAngle / 2; // 偶数：6点钟方向 + segmentAngle/2
      // 每个奖品的角度 = 第一个奖品角度 + index * segmentAngle
      const midAngle = firstPrizeAngle + segmentAngle * index;
      console.log(`奖品数量=${total} (${total % 2 === 1 ? '奇数' : '偶数'}), 奖品 ${index + 1} (${prize.name || prize.level || '未命名'}): segmentAngle=${segmentAngle.toFixed(2)}°, firstPrizeAngle=${firstPrizeAngle.toFixed(2)}°, midAngle=${midAngle.toFixed(2)}°`);
      const midRad = (midAngle * Math.PI) / 180;
      // 计算整体中心点相对于转盘中心的位置偏移
      const offsetX = overlayRadius * Math.cos(midRad);
      const offsetY = overlayRadius * Math.sin(midRad);
      console.log(`奖品 ${index + 1} 中心点位置: offsetX=${offsetX.toFixed(2)}px, offsetY=${offsetY.toFixed(2)}px, overlayRadius=${overlayRadius.toFixed(2)}px`);
      
      const displayName = prize.isEmptyPrize ? '谢谢参与' : (prize.name || prize.level || `奖项${index + 1}`);
      const key = prize._duplicateId || prize.id || `overlay-${index}`;
      
      // 奖品整体容器：将图片和文字作为一个整体
      // 使用 transform-origin: center center 确保以整体中心点为基准
      return (
        <div
          key={key}
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            // 先将元素的左上角移动到转盘中心，然后通过translate(-50%, -50%)将元素自身中心点对齐到转盘中心
            // 再加上offsetX和offsetY，将整体中心点移动到对应角度位置
            transform: `translate(calc(-50% + ${offsetX}px), calc(-50% + ${offsetY}px))`,
            transformOrigin: 'center center', // 确保以整体中心点为变换原点
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center', // 水平居中
            justifyContent: 'center', // 垂直居中
            textAlign: 'center',
            width: `${Math.max(imageSize, 48)}px`,
            pointerEvents: 'none',
            zIndex: 4
          }}
        >
          {prize.image ? (
            <img
              src={prize.image}
              alt={displayName}
              style={{
                width: imageSize,
                height: imageSize,
                objectFit: 'cover',
                borderRadius: 12,
                marginBottom: 4,
                boxShadow: '0 2px 6px rgba(0,0,0,0.25)'
              }}
            />
          ) : (
            <div
              style={{
                width: imageSize,
                height: imageSize,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: imageSize * 0.55,
                color: '#fff',
                marginBottom: 4
              }}
            >
              {prize.isEmptyPrize ? '📦' : '🎁'}
            </div>
          )}
          <span
            style={{
              color: '#fff',
              fontWeight: 600,
              fontSize,
              textShadow: '0 2px 4px rgba(0,0,0,0.45)',
              lineHeight: 1.15
            }}
          >
            {displayName}
          </span>
        </div>
      );
    });
  };

  // 当奖品总数 <= 2 时，强制关闭（显示谢谢参与）
  useEffect(() => {
    if (shouldAutoClose && activityConfig.hideThankYouPrize) {
      setActivityConfig(prev => ({ ...prev, hideThankYouPrize: false }));
    }
  }, [shouldAutoClose, activityConfig.hideThankYouPrize]);

  const [lotteryResult, setLotteryResult] = useState(null);

  // 导航菜单
  const navItems = [
    { id: 'homepage', name: '首页', icon: '🏠' }
  ];

  // 更新配置
  const updateConfig = (key, value) => {
    setActivityConfig(prev => ({
      ...prev,
      [key]: value
    }));
  };

  // 更新嵌套配置
  const updateNestedConfig = (parentKey, childKey, value) => {
    setActivityConfig(prev => ({
      ...prev,
      [parentKey]: {
        ...prev[parentKey],
        [childKey]: value
      }
    }));
  };

  // 更新派奖方式配置
  const updateDistributionConfig = (key, value) => {
    setActivityConfig(prev => {
      const newDistributionMethod = {
        ...prev.distributionMethod,
        [key]: value
      };
      
      // 验证：不能两个都不限制
      const totalUnlimited = newDistributionMethod.totalDrawChances === 'unlimited';
      const dailyUnlimited = newDistributionMethod.dailyDrawChances === 'unlimited';
      
      if (totalUnlimited && dailyUnlimited) {
        alert('总抽奖机会和每日抽奖机会不能同时设置为"不限"，请至少限制其中一个！');
        // 恢复到之前的配置
        return prev;
      }
      
      return {
        ...prev,
        distributionMethod: newDistributionMethod
      };
    });
  };

  // 只允许输入数字
  const handleNumberInput = (e, callback) => {
    const value = e.target.value;
    // 只允许数字
    if (value === '' || /^\d+$/.test(value)) {
      callback(value === '' ? 0 : parseInt(value) || 0);
    }
  };

  // 更新奖品
  const updatePrize = (index, field, value) => {
    const newPrizes = [...activityConfig.prizes];
    newPrizes[index] = { ...newPrizes[index], [field]: value };
    setActivityConfig(prev => ({ ...prev, prizes: newPrizes }));
  };

  // 添加奖品
  const addPrize = () => {
    // 限制最多11个奖品（包括"谢谢参与"）
    const MAX_PRIZES = 11;
    if (activityConfig.prizes.length >= MAX_PRIZES) {
      alert(`最多只能添加${MAX_PRIZES}个奖品`);
      return;
    }
    
    const prizeIndex = activityConfig.prizes.length;
    const newPrize = {
        id: Date.now(),
        level: `奖项${numberToChinese(prizeIndex)}`, // 因为第一个是"谢谢参与"（index 0），所以新奖品从"奖项一"开始
      name: '新奖品',
      type: 'selfSelected',
      subType: 'physicalGift',
      probability: 10,
      color: '#FF6B6B',
      icon: '🎁',
      coupon: 'PRIZE_NEW',
      quantity: 1,
      image: '',
      description: '',
      repeatWinLimit: 'unlimited',
      introduction: 'hide',
      introductionText: '',
      payToRedeem: 'close',
      redeemMethod: 'pickup',
      isCommon: false,
      isConsolation: false
    };
    setActivityConfig(prev => ({
      ...prev,
      prizes: [...prev.prizes, newPrize]
    }));
    // 切换到新添加的奖品
    setActivePrizeIndex(prizeIndex);
  };

  // 删除奖品
  const removePrize = (index) => {
    // 不能删除第一个奖项（谢谢参与）
    if (index === 0) {
      alert('不能删除"谢谢参与"奖项');
      return;
    }
    if (activityConfig.prizes.length > 1) {
      const newPrizes = activityConfig.prizes.filter((_, i) => i !== index);
      setActivityConfig(prev => ({ ...prev, prizes: newPrizes }));
      // 调整当前选中的索引
      if (activePrizeIndex >= newPrizes.length) {
        setActivePrizeIndex(Math.max(0, newPrizes.length - 1));
      } else if (activePrizeIndex > index) {
        setActivePrizeIndex(activePrizeIndex - 1);
      }
    }
  };

  // 奖项标签导航翻页 - 最多显示5个
  const MAX_VISIBLE_TABS = 5;
  
  // 将数字转换为中文数字（支持1-99）
  const numberToChinese = (num) => {
    const chineseNumbers = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    const chineseUnits = ['', '十', '百'];
    
    if (num <= 0) return '';
    if (num < 10) return chineseNumbers[num];
    if (num === 10) return '十';
    if (num < 20) return '十' + chineseNumbers[num % 10];
    if (num < 100) {
      const tens = Math.floor(num / 10);
      const ones = num % 10;
      return chineseNumbers[tens] + '十' + (ones > 0 ? chineseNumbers[ones] : '');
    }
    return num.toString(); // 超过99的数字直接显示阿拉伯数字
  };
  
  const scrollPrizeTabs = (direction) => {
    const totalPrizes = activityConfig.prizes.length;
    if (totalPrizes <= MAX_VISIBLE_TABS) {
      // 如果总数不超过5个，不需要翻页
      return;
    }
    
    setPrizeTabsStartIndex(prev => {
      if (direction === 'left') {
        // 向左翻页：减少起始索引
        const newIndex = Math.max(0, prev - MAX_VISIBLE_TABS);
        return newIndex;
      } else {
        // 向右翻页：增加起始索引
        const maxStartIndex = Math.max(0, totalPrizes - MAX_VISIBLE_TABS);
        const newIndex = Math.min(maxStartIndex, prev + MAX_VISIBLE_TABS);
        return newIndex;
      }
    });
  };

  // 当奖品数量变化时，调整起始索引
  useEffect(() => {
    const totalPrizes = activityConfig.prizes.length;
    if (totalPrizes <= MAX_VISIBLE_TABS) {
      // 如果总数不超过5个，始终从0开始
      setPrizeTabsStartIndex(0);
      return;
    }
    
    // 确保起始索引不超过最大范围
    const maxStartIndex = Math.max(0, totalPrizes - MAX_VISIBLE_TABS);
    setPrizeTabsStartIndex(prev => Math.min(prev, maxStartIndex));
  }, [activityConfig.prizes.length]);

  // 当切换奖品时，确保当前选中的奖品在可见范围内
  useEffect(() => {
    const totalPrizes = activityConfig.prizes.length;
    if (totalPrizes <= MAX_VISIBLE_TABS) {
      // 如果总数不超过5个，始终从0开始
      setPrizeTabsStartIndex(0);
      return;
    }
    
    const maxStartIndex = Math.max(0, totalPrizes - MAX_VISIBLE_TABS);
    
    if (activePrizeIndex < prizeTabsStartIndex) {
      // 当前选中的在可见范围之前，向前翻页，让选中的标签显示在第一个位置
      setPrizeTabsStartIndex(Math.max(0, activePrizeIndex));
    } else if (activePrizeIndex >= prizeTabsStartIndex + MAX_VISIBLE_TABS) {
      // 当前选中的在可见范围之后，向后翻页，让选中的标签显示在最后一个位置
      const newStartIndex = Math.max(0, activePrizeIndex - MAX_VISIBLE_TABS + 1);
      setPrizeTabsStartIndex(Math.min(maxStartIndex, newStartIndex));
    }
  }, [activePrizeIndex, activityConfig.prizes.length]);

  // 获取可见的奖项标签
  const getVisiblePrizes = () => {
    const totalPrizes = activityConfig.prizes.length;
    const endIndex = Math.min(prizeTabsStartIndex + MAX_VISIBLE_TABS, totalPrizes);
    return activityConfig.prizes.slice(prizeTabsStartIndex, endIndex).map((prize, localIndex) => ({
      prize,
      globalIndex: prizeTabsStartIndex + localIndex
    }));
  };

  const canScrollLeft = prizeTabsStartIndex > 0;
  const canScrollRight = prizeTabsStartIndex + MAX_VISIBLE_TABS < activityConfig.prizes.length;

  // 保存活动
  const handleSave = () => {
    console.log('保存活动配置:', activityConfig);
    alert('活动配置已保存！');
  };

  // 发布活动
  const handlePublish = () => {
    setIsPublished(true);
    alert('活动已发布！');
  };

  // 抽奖结果处理
  const handleLotteryResult = (result) => {
    setLotteryResult(result);
    setParticipantCount(prev => prev + 1);
  };

  // 渲染配置面板
  const renderConfigPanel = () => {
    switch (activeTab) {
      case 'homepage':
        return (
          <div className="config-panel">
            <div className="config-tabs">
              <div 
                className={`tab ${activeSubTab === 'basic' ? 'active' : ''}`}
                onClick={() => setActiveSubTab('basic')}
              >
                基础设置
              </div>
              <div 
                className={`tab ${activeSubTab === 'distribution' ? 'active' : ''}`}
                onClick={() => setActiveSubTab('distribution')}
              >
                派奖方式
              </div>
              <div 
                className={`tab ${activeSubTab === 'awards' ? 'active' : ''}`}
                onClick={() => setActiveSubTab('awards')}
              >
                奖项设置
              </div>
              <div 
                className={`tab ${activeSubTab === 'advanced' ? 'active' : ''}`}
                onClick={() => setActiveSubTab('advanced')}
              >
                高级设置
              </div>
            </div>
            
            <div className="config-content">
              {activeSubTab === 'basic' && (
              <div className="config-section">
                <h4>基础选项</h4>
                <div className="form-group">
                  <label>活动标题</label>
                  <input
                    type="text"
                    value={activityConfig.title}
                    onChange={(e) => updateConfig('title', e.target.value)}
                    placeholder="请输入活动标题"
                  />
                </div>

                <div className="form-group">
                  <label>活动时间</label>
                  <div className="time-inputs">
                    <input
                      type="datetime-local"
                      value={activityConfig.startTime}
                      onChange={(e) => updateConfig('startTime', e.target.value)}
                    />
                    <span>至</span>
                    <input
                      type="datetime-local"
                      value={activityConfig.endTime}
                      onChange={(e) => updateConfig('endTime', e.target.value)}
                    />
                  </div>
                </div>

                  {/* 第一部分：抽奖主题 */}
                  <div className="config-subsection" style={{ marginTop: 30 }}>
                    <h5>抽奖主题</h5>
                    <div className="form-group">
                      <label>主题图片:</label>
                      <input 
                        type="file" 
                        accept="image/*" 
                        style={{ display: 'none' }}
                        id="theme-image-upload"
                        onChange={e => {
                          const file = e.target.files && e.target.files[0];
                          if (file) {
                            const reader = new FileReader();
                            reader.onload = ev => {
                              setActivityConfig(prev => ({
                                ...prev,
                                lotteryTheme: {
                                  ...prev.lotteryTheme,
                                  titleImage: ev.target.result
                                }
                              }));
                            };
                            reader.readAsDataURL(file);
                          }
                        }} 
                      />
                      {activityConfig.lotteryTheme.titleImage ? (
                        <div style={{ position: 'relative', width: '120px', height: '120px', border: '1px solid #ddd', borderRadius: 4, overflow: 'hidden', background: '#fafafa', cursor: 'pointer' }}
                          onClick={() => document.getElementById('theme-image-upload').click()}
                        >
                          <img
                            src={activityConfig.lotteryTheme.titleImage}
                            alt="主题图片预览"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                          />
                          <button
                            type="button"
                            style={{
                              position: 'absolute',
                              top: 5,
                              right: 5,
                              width: 24,
                              height: 24,
                              background: 'rgba(0, 0, 0, 0.6)',
                              color: 'white',
                              border: 'none',
                              borderRadius: '50%',
                              fontSize: 18,
                              lineHeight: 1,
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: 0,
                              zIndex: 10
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setActivityConfig(prev => ({
                                ...prev,
                                lotteryTheme: {
                                  ...prev.lotteryTheme,
                                  titleImage: ''
                                }
                              }));
                              document.getElementById('theme-image-upload').value = '';
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ) : (
                        <div 
                          style={{ 
                            width: '120px', 
                            height: '120px', 
                            border: '2px dashed #d9d9d9', 
                            borderRadius: 4, 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center', 
                            cursor: 'pointer', 
                            transition: 'all 0.3s ease',
                            background: '#fafafa'
                          }}
                          onClick={() => document.getElementById('theme-image-upload').click()}
                        >
                          <span style={{ fontSize: 32, color: '#999', lineHeight: 1, fontWeight: 300 }}>+</span>
                        </div>
                      )}
                      <div style={{ marginTop: 8, color: '#999', fontSize: 13 }}>
                        提示：上传后可在预览中拖动调整位置
                      </div>
                    </div>
                  </div>

                  {/* 第二部分：背景 */}
                  <div className="config-subsection" style={{ marginTop: 30 }}>
                    <h5>背景</h5>
                    <div className="form-group">
                      <label>背景图片:</label>
                      <div className="radio-group-inline" style={{ marginBottom: 10 }}>
                        <label>
                          <input
                            type="radio"
                            name="bgImageShow"
                            value="hide"
                            checked={!activityConfig.backgroundImage.show}
                            onChange={(e) => setActivityConfig(prev => ({
                              ...prev,
                              backgroundImage: { ...prev.backgroundImage, show: false }
                            }))}
                          />
                          隐藏
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="bgImageShow"
                            value="show"
                            checked={activityConfig.backgroundImage.show}
                            onChange={(e) => setActivityConfig(prev => ({
                              ...prev,
                              backgroundImage: { ...prev.backgroundImage, show: true }
                            }))}
                          />
                          显示
                        </label>
                      </div>
                      {activityConfig.backgroundImage.show && (
                        <>
                          <input 
                            type="file" 
                            accept="image/*" 
                            style={{ display: 'none' }}
                            id="bg-image-upload"
                            onChange={e => {
                              const file = e.target.files && e.target.files[0];
                              if (file) {
                                const reader = new FileReader();
                                reader.onload = ev => {
                                  setActivityConfig(prev => ({
                                    ...prev,
                                    backgroundImage: {
                                      ...prev.backgroundImage,
                                      image: ev.target.result
                                    }
                                  }));
                                };
                                reader.readAsDataURL(file);
                              }
                            }} 
                          />
                          {activityConfig.backgroundImage.image ? (
                            <div style={{ position: 'relative', width: '120px', height: '120px', border: '1px solid #ddd', borderRadius: 4, overflow: 'hidden', background: '#fafafa', marginBottom: 10, cursor: 'pointer' }}
                              onClick={() => document.getElementById('bg-image-upload').click()}
                            >
                              <img
                                src={activityConfig.backgroundImage.image}
                                alt="背景图片预览"
                                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                              />
                              <button
                                type="button"
                                style={{
                                  position: 'absolute',
                                  top: 5,
                                  right: 5,
                                  width: 24,
                                  height: 24,
                                  background: 'rgba(0, 0, 0, 0.6)',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '50%',
                                  fontSize: 18,
                                  lineHeight: 1,
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  padding: 0,
                                  zIndex: 10
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setActivityConfig(prev => ({
                                    ...prev,
                                    backgroundImage: {
                                      ...prev.backgroundImage,
                                      image: ''
                                    }
                                  }));
                                  document.getElementById('bg-image-upload').value = '';
                                }}
                              >
                                ×
                              </button>
                            </div>
                          ) : (
                            <div 
                              style={{ 
                                width: '120px', 
                                height: '120px', 
                                border: '2px dashed #d9d9d9', 
                                borderRadius: 4, 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center', 
                                cursor: 'pointer', 
                                transition: 'all 0.3s ease',
                                background: '#fafafa',
                                marginBottom: 10
                              }}
                              onClick={() => document.getElementById('bg-image-upload').click()}
                            >
                              <span style={{ fontSize: 32, color: '#999', lineHeight: 1, fontWeight: 300 }}>+</span>
                            </div>
                          )}
                          <div style={{ color: '#999', fontSize: 13 }}>
                            建议尺寸: 640px*1600px,其中主要展示区域高度为1008px,大小不超过1M
                          </div>
                        </>
                      )}
                    </div>
              </div>

                  {/* 第三部分：转盘 */}
                  <div className="config-subsection" style={{ marginTop: 30 }}>
                    <h5>转盘</h5>
                    
                    {/* 大转盘 */}
                    <div className="form-group">
                      <label>大转盘:</label>
                      <input 
                        type="file" 
                        accept="image/*" 
                        style={{ display: 'none' }}
                        id="wheel-image-upload"
                        onChange={e => {
                          const file = e.target.files && e.target.files[0];
                          if (file) {
                            const reader = new FileReader();
                            reader.onload = ev => {
                              setActivityConfig(prev => ({
                                ...prev,
                                wheel: {
                                  ...prev.wheel,
                                  wheelImage: ev.target.result
                                }
                              }));
                            };
                            reader.readAsDataURL(file);
                          }
                        }} 
                      />
                      {activityConfig.wheel.wheelImage ? (
                        <div style={{ position: 'relative', width: '120px', height: '120px', border: '1px solid #ddd', borderRadius: 4, overflow: 'hidden', background: '#fafafa', marginBottom: 10, cursor: 'pointer' }}
                          onClick={() => document.getElementById('wheel-image-upload').click()}
                        >
                          <img
                            src={activityConfig.wheel.wheelImage}
                            alt="大转盘预览"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                          />
                          <button
                            type="button"
                            style={{
                              position: 'absolute',
                              top: 5,
                              right: 5,
                              width: 24,
                              height: 24,
                              background: 'rgba(0, 0, 0, 0.6)',
                              color: 'white',
                              border: 'none',
                              borderRadius: '50%',
                              fontSize: 18,
                              lineHeight: 1,
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: 0,
                              zIndex: 10
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setActivityConfig(prev => ({
                                ...prev,
                                wheel: {
                                  ...prev.wheel,
                                  wheelImage: ''
                                }
                              }));
                              document.getElementById('wheel-image-upload').value = '';
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ) : (
                        <div 
                          style={{ 
                            width: '120px', 
                            height: '120px', 
                            border: '2px dashed #d9d9d9', 
                            borderRadius: 4, 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center', 
                            cursor: 'pointer', 
                            transition: 'all 0.3s ease',
                            background: '#fafafa',
                            marginBottom: 10
                          }}
                          onClick={() => document.getElementById('wheel-image-upload').click()}
                        >
                          <span style={{ fontSize: 32, color: '#999', lineHeight: 1, fontWeight: 300 }}>+</span>
                        </div>
                      )}
                      <div style={{ color: '#999', fontSize: 13 }}>
                        建议尺寸: 700px*706px, 大小不超过1M
                      </div>
                    </div>

                    {/* 切割线 */}
                    <div className="form-group">
                      <label>切割线:</label>
                      <input 
                        type="file" 
                        accept="image/*" 
                        style={{ display: 'none' }}
                        id="divider-line-upload"
                        onChange={e => {
                          const file = e.target.files && e.target.files[0];
                          if (file) {
                            const reader = new FileReader();
                            reader.onload = ev => {
                              setActivityConfig(prev => ({
                                ...prev,
                                wheel: {
                                  ...prev.wheel,
                                  dividerLine: ev.target.result
                                }
                              }));
                            };
                            reader.readAsDataURL(file);
                          }
                        }} 
                      />
                      {activityConfig.wheel.dividerLine ? (
                        <div style={{ position: 'relative', width: '120px', height: '120px', border: '1px solid #ddd', borderRadius: 4, overflow: 'hidden', background: '#fafafa', marginBottom: 10, cursor: 'pointer' }}
                          onClick={() => document.getElementById('divider-line-upload').click()}
                        >
                          <img
                            src={activityConfig.wheel.dividerLine}
                            alt="切割线预览"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                          />
                          <button
                            type="button"
                            style={{
                              position: 'absolute',
                              top: 5,
                              right: 5,
                              width: 24,
                              height: 24,
                              background: 'rgba(0, 0, 0, 0.6)',
                              color: 'white',
                              border: 'none',
                              borderRadius: '50%',
                              fontSize: 18,
                              lineHeight: 1,
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: 0,
                              zIndex: 10
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setActivityConfig(prev => ({
                                ...prev,
                                wheel: {
                                  ...prev.wheel,
                                  dividerLine: ''
                                }
                              }));
                              document.getElementById('divider-line-upload').value = '';
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ) : (
                        <div 
                          style={{ 
                            width: '120px', 
                            height: '120px', 
                            border: '2px dashed #d9d9d9', 
                            borderRadius: 4, 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center', 
                            cursor: 'pointer', 
                            transition: 'all 0.3s ease',
                            background: '#fafafa',
                            marginBottom: 10
                          }}
                          onClick={() => document.getElementById('divider-line-upload').click()}
                        >
                          <span style={{ fontSize: 32, color: '#999', lineHeight: 1, fontWeight: 300 }}>+</span>
                        </div>
                      )}
                      <div style={{ color: '#999', fontSize: 13 }}>
                        建议尺寸: 3px*252px, 大小不超过1M
                      </div>
                    </div>

                    {/* 开始按钮 */}
                    <div className="form-group">
                      <label>开始按钮:</label>
                      <input 
                        type="file" 
                        accept="image/*" 
                        style={{ display: 'none' }}
                        id="start-button-upload"
                        onChange={e => {
                          const file = e.target.files && e.target.files[0];
                          if (file) {
                            const reader = new FileReader();
                            reader.onload = ev => {
                              setActivityConfig(prev => ({
                                ...prev,
                                wheel: {
                                  ...prev.wheel,
                                  startButton: ev.target.result
                                }
                              }));
                            };
                            reader.readAsDataURL(file);
                          }
                        }} 
                      />
                      {activityConfig.wheel.startButton ? (
                        <div style={{ position: 'relative', width: '120px', height: '120px', border: '1px solid #ddd', borderRadius: 4, overflow: 'hidden', background: '#fafafa', marginBottom: 10, cursor: 'pointer' }}
                          onClick={() => document.getElementById('start-button-upload').click()}
                        >
                          <img
                            src={activityConfig.wheel.startButton}
                            alt="开始按钮预览"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                          />
                          <button
                            type="button"
                            style={{
                              position: 'absolute',
                              top: 5,
                              right: 5,
                              width: 24,
                              height: 24,
                              background: 'rgba(0, 0, 0, 0.6)',
                              color: 'white',
                              border: 'none',
                              borderRadius: '50%',
                              fontSize: 18,
                              lineHeight: 1,
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: 0,
                              zIndex: 10
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setActivityConfig(prev => ({
                                ...prev,
                                wheel: {
                                  ...prev.wheel,
                                  startButton: ''
                                }
                              }));
                              document.getElementById('start-button-upload').value = '';
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ) : (
                        <div 
                          style={{ 
                            width: '120px', 
                            height: '120px', 
                            border: '2px dashed #d9d9d9', 
                            borderRadius: 4, 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center', 
                            cursor: 'pointer', 
                            transition: 'all 0.3s ease',
                            background: '#fafafa',
                            marginBottom: 10
                          }}
                          onClick={() => document.getElementById('start-button-upload').click()}
                        >
                          <span style={{ fontSize: 32, color: '#999', lineHeight: 1, fontWeight: 300 }}>+</span>
                        </div>
                      )}
                      <div style={{ color: '#999', fontSize: 13 }}>
                        建议尺寸: 150px*220px, 大小不超过1M
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeSubTab === 'distribution' && (
                <div className="config-section">
                  {/* 抽奖限制 */}
                  <div className="config-subsection">
                    <h5>抽奖限制</h5>
                    
                    <div className="form-group-inline">
                      <label className="inline-label">总抽奖机会:</label>
                      <div className="radio-group-inline">
                        <label>
                          <input
                            type="radio"
                            name="totalDrawChances"
                            value="unlimited"
                            checked={activityConfig.distributionMethod.totalDrawChances === 'unlimited'}
                            onChange={(e) => updateDistributionConfig('totalDrawChances', e.target.value)}
                          />
                          不限
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="totalDrawChances"
                            value="limited"
                            checked={activityConfig.distributionMethod.totalDrawChances === 'limited'}
                            onChange={(e) => updateDistributionConfig('totalDrawChances', e.target.value)}
                          />
                          限制
                        </label>
                      </div>
                      {activityConfig.distributionMethod.totalDrawChances === 'limited' && (
                        <>
                          <span className="inline-text">每人最多有</span>
                          <input
                            type="text"
                            className="inline-input"
                            value={activityConfig.distributionMethod.totalDrawLimit || ''}
                            onChange={(e) => handleNumberInput(e, (value) => updateDistributionConfig('totalDrawLimit', value))}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            placeholder=""
                          />
                          <span className="inline-text">次</span>
                        </>
                      )}
                    </div>

                    <div className="form-group-inline">
                      <label className="inline-label">每日抽奖机会:</label>
                      <div className="radio-group-inline">
                        <label>
                          <input
                            type="radio"
                            name="dailyDrawChances"
                            value="unlimited"
                            checked={activityConfig.distributionMethod.dailyDrawChances === 'unlimited'}
                            onChange={(e) => updateDistributionConfig('dailyDrawChances', e.target.value)}
                          />
                          不限
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="dailyDrawChances"
                            value="limited"
                            checked={activityConfig.distributionMethod.dailyDrawChances === 'limited'}
                            onChange={(e) => updateDistributionConfig('dailyDrawChances', e.target.value)}
                          />
                          限制
                        </label>
                      </div>
                      {activityConfig.distributionMethod.dailyDrawChances === 'limited' && (
                        <>
                          <span className="inline-text">每人每日有</span>
                          <input
                            type="text"
                            className="inline-input"
                            value={activityConfig.distributionMethod.dailyDrawLimit || ''}
                            onChange={(e) => handleNumberInput(e, (value) => updateDistributionConfig('dailyDrawLimit', value))}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            placeholder=""
                          />
                          <span className="inline-text">次抽奖机会</span>
                        </>
                      )}
                    </div>
                  </div>

                  {/* 中奖限制 */}
                  <div className="config-subsection">
                    <h5>中奖限制</h5>
                    
                    <div className="form-group-inline">
                      <label className="inline-label">每人中奖次数:</label>
                      <span className="inline-text">每人最多可中奖</span>
                      <input
                        type="text"
                        className="inline-input"
                        value={activityConfig.distributionMethod.maxWinPerPerson || ''}
                        onChange={(e) => handleNumberInput(e, (value) => updateDistributionConfig('maxWinPerPerson', value))}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        placeholder=""
                      />
                      <span className="inline-text">次</span>
                    </div>

                    <div className="form-group-inline">
                      <label className="inline-label">每日中奖次数:</label>
                      <div className="radio-group-inline">
                        <label>
                          <input
                            type="radio"
                            name="dailyWinLimit"
                            value="unlimited"
                            checked={activityConfig.distributionMethod.dailyWinLimit === 'unlimited'}
                            onChange={(e) => updateDistributionConfig('dailyWinLimit', e.target.value)}
                          />
                          不限
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="dailyWinLimit"
                            value="limited"
                            checked={activityConfig.distributionMethod.dailyWinLimit === 'limited'}
                            onChange={(e) => updateDistributionConfig('dailyWinLimit', e.target.value)}
                          />
                          限制
                        </label>
                      </div>
                      {activityConfig.distributionMethod.dailyWinLimit === 'limited' && (
                        <>
                          <span className="inline-text">每人每日可中奖</span>
                          <input
                            type="text"
                            className="inline-input"
                            value={activityConfig.distributionMethod.dailyWinLimitCount || ''}
                            onChange={(e) => handleNumberInput(e, (value) => updateDistributionConfig('dailyWinLimitCount', value))}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            placeholder=""
                          />
                          <span className="inline-text">次</span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {activeSubTab === 'awards' && (
                <div className="config-section">
                  <div className="prize-config-header">
                    <h4>请设置活动需要派发的奖项</h4>
                    <div className="prize-header-actions">
                      <button 
                        className="btn-add" 
                        onClick={addPrize}
                        disabled={activityConfig.prizes.length >= 11}
                        title={activityConfig.prizes.length >= 11 ? '最多只能添加11个奖品' : '添加奖品'}
                      >
                        +
                      </button>
                      <button 
                        className="btn-remove" 
                        onClick={() => removePrize(activePrizeIndex)}
                        disabled={activityConfig.prizes.length <= 1 || activePrizeIndex === 0}
                        title={activePrizeIndex === 0 ? '不能删除"谢谢参与"奖项' : '删除奖项'}
                      >
                        -
                      </button>
                    </div>
                  </div>

                  {/* 奖项标签导航 */}
                  <div className="prize-tabs-wrapper">
                    <button 
                      className={`prize-tabs-arrow prize-tabs-arrow-left ${!canScrollLeft ? 'disabled' : ''}`}
                      onClick={() => canScrollLeft && scrollPrizeTabs('left')}
                      disabled={!canScrollLeft}
                      title="向左翻页"
                    >
                      &lt;
                    </button>
                    <div className="prize-tabs" ref={prizeTabsRef}>
                      {getVisiblePrizes().map(({ prize, globalIndex }) => (
                        <div
                          key={prize.id || globalIndex}
                          className={`prize-tab ${activePrizeIndex === globalIndex ? 'active' : ''}`}
                          onClick={() => setActivePrizeIndex(globalIndex)}
                        >
                          {globalIndex === 0 ? '谢谢参与' : `奖项${numberToChinese(globalIndex)}`}
                        </div>
                      ))}
                    </div>
                    <button 
                      className={`prize-tabs-arrow prize-tabs-arrow-right ${!canScrollRight ? 'disabled' : ''}`}
                      onClick={() => canScrollRight && scrollPrizeTabs('right')}
                      disabled={!canScrollRight}
                      title="向右翻页"
                    >
                      &gt;
                    </button>
                  </div>

                  {activityConfig.prizes[activePrizeIndex] && (
                    <>
                      {/* 基本选项 */}
                      <div className="prize-options-section">
                        <div className="form-group-inline">
                          <label className="inline-label">奖项名称:<span className="required">*</span></label>
                          <input
                            type="text"
                            className="inline-input-full"
                            value={activityConfig.prizes[activePrizeIndex].name || ''}
                            onChange={(e) => {
                              const value = e.target.value;
                              // 限制最多6个字符
                              if (value.length <= 6) {
                                updatePrize(activePrizeIndex, 'name', value);
                              }
                            }}
                            maxLength={6}
                            placeholder="请输入奖项名称（最多6个字）"
                          />
                        </div>

                        {!(activePrizeIndex === 0 || activityConfig.prizes[activePrizeIndex].isEmptyPrize) && (
                          <div className="form-group-inline">
                            <label className="inline-label">奖项数量:<span className="required">*</span></label>
                            <input
                              type="text"
                              className="inline-input"
                              value={activityConfig.prizes[activePrizeIndex].quantity || ''}
                              onChange={(e) => handleNumberInput(e, (value) => updatePrize(activePrizeIndex, 'quantity', value))}
                              onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              placeholder=""
                            />
                          </div>
                        )}

                        {!(activePrizeIndex === 0 || activityConfig.prizes[activePrizeIndex]?.isEmptyPrize) && (
                          <div className="form-group-inline">
                            <label className="inline-label">中奖概率:</label>
                            <input
                              type="text"
                              className="inline-input"
                              value={activityConfig.prizes[activePrizeIndex].probability || ''}
                              onChange={(e) => handleNumberInput(e, (value) => {
                                const numValue = parseInt(value) || 0;
                                // 限制在0-100之间
                                const clampedValue = Math.max(0, Math.min(100, numValue));
                                updatePrize(activePrizeIndex, 'probability', clampedValue);
                              })}
                              onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              placeholder=""
                            />
                            <span className="inline-text">%</span>
                          </div>
                        )}

                        {/* 空奖隐藏选项 - 只在"谢谢参与"奖项中显示 */}
                        {(activePrizeIndex === 0 || activityConfig.prizes[activePrizeIndex]?.isEmptyPrize) && (
                          <div className="form-group-inline">
                            <label className="inline-label">空奖隐藏:</label>
                            <div className="radio-group-inline">
                              <label>
                                <input
                                  type="radio"
                                  name="hideThankYouPrize"
                                  value="hide"
                                  checked={activityConfig.hideThankYouPrize}
                                  onChange={() => setActivityConfig(prev => ({ ...prev, hideThankYouPrize: true }))}
                                  disabled={shouldAutoClose}
                                />
                                开启
                              </label>
                              <label>
                                <input
                                  type="radio"
                                  name="hideThankYouPrize"
                                  value="show"
                                  checked={!activityConfig.hideThankYouPrize}
                                  onChange={() => setActivityConfig(prev => ({ ...prev, hideThankYouPrize: false }))}
                                  disabled={shouldAutoClose}
                                />
                                关闭
                              </label>
                            </div>
                          </div>
                        )}

                        <div className="form-group">
                          <label>图片:</label>
                          <div className="image-intro-upload">
                            <input
                              type="file"
                              accept="image/jpeg,image/jpg,image/bmp,image/png,image/gif"
                              className="image-file-input"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  // 检查文件大小（200KB = 204800 bytes）
                                  if (file.size > 204800) {
                                    alert('图片大小不能超过200KB');
                                    e.target.value = '';
                                    return;
                                  }
                                  // 检查文件类型
                                  const validTypes = ['image/jpeg', 'image/jpg', 'image/bmp', 'image/png', 'image/gif'];
                                  if (!validTypes.includes(file.type)) {
                                    alert('图片格式只能是 jpg/bmp/png/gif');
                                    e.target.value = '';
                                    return;
                                  }
                                  const reader = new FileReader();
                                  reader.onloadend = () => {
                                    const img = new Image();
                                    img.onload = () => {
                                      // 检查图片尺寸
                                      if (img.width > 512 || img.height > 512) {
                                        alert('图片长宽不能超过512px');
                                        e.target.value = '';
                                        return;
                                      }
                                      updatePrize(activePrizeIndex, 'image', reader.result);
                                    };
                                    img.onerror = () => {
                                      alert('图片加载失败，请重新选择');
                                      e.target.value = '';
                                    };
                                    img.src = reader.result;
                                  };
                                  reader.readAsDataURL(file);
                                }
                              }}
                              style={{ display: 'none' }}
                              id={`image-upload-${activePrizeIndex}`}
                            />
                            {activityConfig.prizes[activePrizeIndex].image ? (
                              <div className="image-preview-container">
                                <div className="image-preview-item">
                                  <img 
                                    src={activityConfig.prizes[activePrizeIndex].image} 
                                    alt="奖品图片预览"
                                    className="preview-image"
                                  />
                                  <button 
                                    type="button"
                                    className="remove-image-btn"
                                    onClick={() => {
                                      updatePrize(activePrizeIndex, 'image', '');
                                      document.getElementById(`image-upload-${activePrizeIndex}`).value = '';
                                    }}
                                  >
                                    ×
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <div 
                                className="image-upload-box"
                                onClick={() => document.getElementById(`image-upload-${activePrizeIndex}`).click()}
                              >
                                <span className="upload-plus">+</span>
                              </div>
                            )}
                          </div>
                        </div>

                        {!(activePrizeIndex === 0 || activityConfig.prizes[activePrizeIndex]?.isEmptyPrize) && (
                          <div className="form-group">
                            <label>奖品介绍（最多30个字）:</label>
                            <textarea
                              className="inline-input-full"
                              rows={3}
                              maxLength={30}
                              value={activityConfig.prizes[activePrizeIndex].description || ''}
                              onChange={(e) => updatePrize(activePrizeIndex, 'description', e.target.value.slice(0, 30))}
                              placeholder="请输入奖品介绍，最多30个字"
                              style={{ resize: 'none' }}
                            />
                            <div style={{ textAlign: 'right', fontSize: 12, color: '#999' }}>
                              {(activityConfig.prizes[activePrizeIndex].description || '').length}/30
                            </div>
                          </div>
                        )}

                        {/* 重复中奖限制 - 谢谢参与不需要此选项 */}
                        {!(activePrizeIndex === 0 || activityConfig.prizes[activePrizeIndex]?.isEmptyPrize) && (
                          <div className="form-group-inline">
                            <label className="inline-label">重复中奖限制:</label>
                            <div className="radio-group-inline">
                              <label>
                                <input
                                  type="radio"
                                  name={`repeatWinLimit-${activePrizeIndex}`}
                                  value="unlimited"
                                  checked={activityConfig.prizes[activePrizeIndex].repeatWinLimit === 'unlimited'}
                                  onChange={(e) => updatePrize(activePrizeIndex, 'repeatWinLimit', e.target.value)}
                                />
                                不限
                              </label>
                              <label>
                                <input
                                  type="radio"
                                  name={`repeatWinLimit-${activePrizeIndex}`}
                                  value="enabled"
                                  checked={activityConfig.prizes[activePrizeIndex].repeatWinLimit === 'enabled'}
                                  onChange={(e) => updatePrize(activePrizeIndex, 'repeatWinLimit', e.target.value)}
                                />
                                开启
                              </label>
                            </div>
                          </div>
                        )}

                      </div>
                    </>
                  )}
                </div>
              )}

              {activeSubTab === 'advanced' && (
                <div className="config-section">
                  <div style={{ padding: 18, color: '#222', fontSize: 15 }}>
                    <div style={{ fontWeight: 700, marginBottom: 12, fontSize: 17, color: '#222' }}>分享预览</div>
                    <div style={{ background: '#fcfcf7', borderRadius: 14, padding: 18, display: 'flex', alignItems: 'center', marginBottom: 12, boxShadow: '0 2px 12px rgba(24,144,255,0.08), 0 1.5px 6px rgba(0,0,0,0.04)' }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontWeight: 800, fontSize: 16, marginBottom: 4, color: '#222', letterSpacing: 0.5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{wechatShare.title}</div>
                        <div style={{ color: '#a0a0a0', fontSize: 14, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontWeight: 500 }}>{wechatShare.desc}</div>
                      </div>
                      {wechatShare.img && (
                        <img 
                          src={wechatShare.img} 
                          alt="" 
                          style={{ width: 54, height: 54, borderRadius: 8, marginLeft: 18, objectFit: 'cover', boxShadow: '0 2px 8px rgba(24,144,255,0.10)' }} 
                        />
                      )}
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <button 
                        style={{ 
                          background: 'none', 
                          border: 'none', 
                          color: '#1890ff', 
                          cursor: 'pointer', 
                          fontSize: 15, 
                          fontWeight: 600, 
                          padding: 0, 
                          textDecoration: 'underline', 
                          borderRadius: 4, 
                          transition: 'color 0.2s' 
                        }} 
                        onClick={() => setShowWechatModal(true)}
                      >
                        编辑
                      </button>
                    </div>
                    {showWechatModal && (
                      <div style={{ position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.18)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div style={{ background: '#fff', borderRadius: 8, minWidth: 520, maxWidth: '96vw', padding: '38px 40px 32px 40px', boxShadow: '0 8px 32px rgba(24,144,255,0.13), 0 2px 8px rgba(0,0,0,0.08)', position: 'relative' }}>
                          <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 28 }}>微信分享设置</div>
                          <div style={{ marginBottom: 18 }}>
                            <div style={{ fontWeight: 500, marginBottom: 6 }}>标题</div>
                            <input 
                              style={{ width: '100%', borderRadius: 4, border: '1px solid #e0e0e0', padding: 8, fontSize: 15 }} 
                              value={wechatShare.title} 
                              onChange={e => setWechatShare(s => ({ ...s, title: e.target.value }))} 
                            />
                          </div>
                          <div style={{ marginBottom: 18 }}>
                            <div style={{ fontWeight: 500, marginBottom: 6 }}>简介</div>
                            <textarea 
                              style={{ width: '100%', borderRadius: 4, border: '1px solid #e0e0e0', padding: 8, fontSize: 15, minHeight: 60 }} 
                              value={wechatShare.desc} 
                              onChange={e => setWechatShare(s => ({ ...s, desc: e.target.value }))} 
                            />
                          </div>
                          <div style={{ marginBottom: 18 }}>
                            <div style={{ fontWeight: 500, marginBottom: 6 }}>图标</div>
                            <div style={{ color: '#aaa', fontSize: 13, marginBottom: 8 }}>建议尺寸120px*120px</div>
                            <input 
                              type="file" 
                              accept="image/*" 
                              style={{ display: 'none' }}
                              id="wechat-icon-upload"
                              onChange={e => {
                                const file = e.target.files && e.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = ev => setWechatShare(s => ({ ...s, img: ev.target.result }));
                                  reader.readAsDataURL(file);
                                }
                              }} 
                            />
                            {wechatShare.img ? (
                              <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                                <div style={{ position: 'relative', width: '120px', height: '120px', border: '1px solid #ddd', borderRadius: 4, overflow: 'hidden', background: '#fafafa' }}>
                                  <img
                                    src={wechatShare.img}
                                    alt="微信分享图标"
                                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                                  />
                                  <button
                                    type="button"
                                    style={{
                                      position: 'absolute',
                                      top: 5,
                                      right: 5,
                                      width: 24,
                                      height: 24,
                                      background: 'rgba(0, 0, 0, 0.6)',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '50%',
                                      fontSize: 18,
                                      lineHeight: 1,
                                      cursor: 'pointer',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      padding: 0,
                                      transition: 'background 0.3s ease'
                                    }}
                                    onMouseEnter={e => e.target.style.background = 'rgba(244, 67, 54, 0.9)'}
                                    onMouseLeave={e => e.target.style.background = 'rgba(0, 0, 0, 0.6)'}
                                    onClick={() => {
                                      setWechatShare(s => ({ ...s, img: '' }));
                                      document.getElementById('wechat-icon-upload').value = '';
                                    }}
                                  >
                                    ×
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <div 
                                style={{ 
                                  width: '120px', 
                                  height: '120px', 
                                  border: '2px dashed #d9d9d9', 
                                  borderRadius: 4, 
                                  display: 'flex', 
                                  alignItems: 'center', 
                                  justifyContent: 'center', 
                                  cursor: 'pointer', 
                                  transition: 'all 0.3s ease',
                                  background: '#fafafa'
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.borderColor = '#007bff';
                                  e.currentTarget.style.background = '#f0f7ff';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.borderColor = '#d9d9d9';
                                  e.currentTarget.style.background = '#fafafa';
                                }}
                                onClick={() => document.getElementById('wechat-icon-upload').click()}
                              >
                                <span style={{ fontSize: 48, color: '#999', lineHeight: 1, fontWeight: 300 }}>+</span>
                              </div>
                            )}
                          </div>
                          <div style={{ textAlign: 'right', marginTop: 24 }}>
                            <button
                              type="button"
                              style={{
                                background: '#f0f0f0',
                                color: '#222',
                                border: 'none',
                                borderRadius: 4,
                                padding: '8px 20px',
                                fontSize: 15,
                                cursor: 'pointer',
                                marginRight: 12
                              }}
                              onClick={() => setShowWechatModal(false)}
                            >
                              取消
                            </button>
                            <button
                              type="button"
                              style={{
                                background: '#1890ff',
                                color: '#fff',
                                border: 'none',
                                borderRadius: 4,
                                padding: '8px 20px',
                                fontSize: 15,
                                cursor: 'pointer'
                              }}
                              onClick={() => setShowWechatModal(false)}
                            >
                              保存
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        );

      case 'prizes':
        // 获取第一个非空奖品作为示例
        const samplePrize = activityConfig.prizes.find(p => !p.isEmptyPrize) || activityConfig.prizes[0];
        const redemptionCode = '888888'; // 示例兑奖码
        
        return (
          <div className="config-panel">
            <div className="config-content">
              <h3>奖品详情页面</h3>
              
              {/* 移动端预览 - 兑奖券页面 */}
              <div className="mobile-preview" style={{ marginTop: '20px' }}>
                <div className="phone-frame">
                  <div className="phone-content" style={{ padding: 0, background: 'white' }}>
                    {/* 顶部收藏栏 */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '12px 16px',
                      background: '#FFF0F5',
                      borderBottom: '1px solid #f0f0f0'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#333' }}>
                        <span>⭐</span>
                        <span>收藏兑奖券</span>
                      </div>
                      <div style={{ fontSize: '18px', color: '#999', cursor: 'pointer' }}>×</div>
                    </div>
                    
                    {/* 奖品信息 */}
                    <div style={{ padding: '20px 16px' }}>
                      {/* 奖品标题 */}
                      <div style={{ fontSize: '20px', fontWeight: 600, color: '#333', marginBottom: '12px' }}>
                        {samplePrize?.name || samplePrize?.level || '价值10元礼品 (示例)'}
                      </div>
                      
                      {/* 兑奖期限 */}
                      <div style={{ fontSize: '13px', color: '#999', marginBottom: '20px' }}>
                        兑奖期限：{(() => {
                          const formatDateTime = (dateTimeStr) => {
                            if (!dateTimeStr) return '';
                            return dateTimeStr.replace(/-/g, '.').replace(' ', ' ');
                          };
                          const startDate = formatDateTime(activityConfig.startTime);
                          const endDate = formatDateTime(activityConfig.endTime);
                          return `${startDate} 00:00 至 ${endDate} 23:59`;
                        })()}
                      </div>
                      
                      {/* 兑奖码 */}
                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'space-between',
                        marginBottom: '20px',
                        padding: '16px',
                        background: '#f8f8f8',
                        borderRadius: '8px'
                      }}>
                        <div>
                          <div style={{ fontSize: '12px', color: '#999', marginBottom: '8px' }}>兑奖码</div>
                          <div style={{ fontSize: '24px', fontWeight: 600, color: '#FF4444', letterSpacing: '2px' }}>
                            {redemptionCode}
                          </div>
                        </div>
                        <button style={{
                          padding: '6px 12px',
                          background: '#f0f0f0',
                          border: 'none',
                          borderRadius: '4px',
                          fontSize: '12px',
                          color: '#666',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '4px'
                        }}>
                          <span>📋</span>
                          <span>复制</span>
                        </button>
                      </div>
                      
                      {/* 立即兑奖按钮 */}
                      <button style={{
                        width: '100%',
                        padding: '14px',
                        background: '#FF69B4',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        fontSize: '16px',
                        fontWeight: 600,
                        cursor: 'pointer',
                        marginBottom: '12px'
                      }}>
                        立即兑奖
                      </button>
                      
                      <div style={{ fontSize: '12px', color: '#999', textAlign: 'center' }}>
                        凭券联系现场工作人员兑奖
                      </div>
                    </div>
                    
                    {/* 分隔线 */}
                    <div style={{ height: '1px', background: 'repeating-linear-gradient(to right, #e0e0e0 0, #e0e0e0 8px, transparent 8px, transparent 16px)', margin: '0 16px' }}></div>
                    
                    {/* 兑奖券详情 */}
                    <div style={{ padding: '20px 16px' }}>
                      <div style={{ fontSize: '16px', fontWeight: 600, color: '#333', marginBottom: '16px' }}>
                        兑奖券详情
                      </div>
                      
                      {/* 兑奖期限 */}
                      <div style={{ marginBottom: '16px' }}>
                        <div style={{ fontSize: '14px', fontWeight: 500, color: '#333', marginBottom: '8px' }}>
                          兑奖期限
                        </div>
                        <div style={{ fontSize: '13px', color: '#666' }}>
                          {(() => {
                            const formatDateTime = (dateTimeStr) => {
                              if (!dateTimeStr) return '';
                              return dateTimeStr.replace(/-/g, '-');
                            };
                            const startDate = formatDateTime(activityConfig.startTime);
                            const endDate = formatDateTime(activityConfig.endTime);
                            return `${startDate} 00:00至${endDate} 23:59`;
                          })()}
                        </div>
                      </div>
                      
                      {/* 可用时段 */}
                      <div style={{ marginBottom: '16px' }}>
                        <div style={{ fontSize: '14px', fontWeight: 500, color: '#333', marginBottom: '8px' }}>
                          可用时段
                        </div>
                        <div style={{ fontSize: '13px', color: '#666' }}>
                          周一至周日
                        </div>
                      </div>
                      
                      {/* 兑奖地址 */}
                      <div style={{ marginBottom: '16px' }}>
                        <div style={{ fontSize: '14px', fontWeight: 500, color: '#333', marginBottom: '8px' }}>
                          兑奖地址
                        </div>
                        <div style={{ fontSize: '13px', color: '#ccc' }}>
                          请填写您的兑奖地址或者门店地址
                        </div>
                      </div>
                      
                      {/* 兑奖须知 */}
                      <div style={{ marginBottom: '16px' }}>
                        <div style={{ fontSize: '14px', fontWeight: 500, color: '#333', marginBottom: '8px' }}>
                          兑奖须知
                        </div>
                        <div style={{ fontSize: '13px', color: '#ccc' }}>
                          不填写则不显示
                        </div>
                      </div>
                    </div>
                    
                    {/* 分隔线 */}
                    <div style={{ height: '1px', background: 'repeating-linear-gradient(to right, #e0e0e0 0, #e0e0e0 8px, transparent 8px, transparent 16px)', margin: '0 16px' }}></div>
                    
                    {/* 客服和更多信息 */}
                    <div style={{ padding: '20px 16px' }}>
                      {/* 客服电话 */}
                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'space-between',
                        marginBottom: '16px',
                        paddingBottom: '16px',
                        borderBottom: '1px solid #f0f0f0'
                      }}>
                        <div style={{ fontSize: '14px', color: '#999' }}>客服电话</div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <span style={{ fontSize: '13px', color: '#999' }}>(未开启)</span>
                          <span style={{ fontSize: '16px', color: '#FF4444' }}>📞</span>
                        </div>
                      </div>
                      
                      {/* 主办单位介绍 */}
                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'space-between',
                        marginBottom: '16px',
                        paddingBottom: '16px',
                        borderBottom: '1px solid #f0f0f0',
                        cursor: 'pointer'
                      }}>
                        <div style={{ fontSize: '14px', color: '#333' }}>主办单位介绍</div>
                        <span style={{ fontSize: '14px', color: '#999' }}>›</span>
                      </div>
                      
                      {/* 了解更多 */}
                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'space-between',
                        cursor: 'pointer'
                      }}>
                        <div style={{ fontSize: '14px', color: '#333' }}>了解更多</div>
                        <span style={{ fontSize: '14px', color: '#999' }}>›</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return (
          <div className="config-panel">
            <div className="config-content">
              <h3>{navItems.find(item => item.id === activeTab)?.name}</h3>
              <p>此功能正在开发中...</p>
            </div>
          </div>
        );
    }
  };

  return (
    <>
      <TopNavbar />
    <div className="lottery-activity-manager">
      {/* 顶部导航栏 */}
      <div className="top-header">
        <div className="header-left">
        </div>
        <div className="header-center">
        </div>
        <div className="header-right">
          <button className="preview-btn" onClick={handlePublish}>
            预览与发布
          </button>
          <button className="save-btn" onClick={handleSave}>
            保存
          </button>
          <button className="exit-btn">退出</button>
        </div>
      </div>

      <div className="main-content">
        {/* 左侧导航 */}
        <div className="sidebar">
          <div className="nav-menu">
            {navItems.map(item => (
              <div
                key={item.id}
                className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
                onClick={() => setActiveTab(item.id)}
              >
                <span className="nav-icon">{item.icon}</span>
                <span className="nav-text">{item.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* 主内容区域 */}
        <div className="content-area">
          {/* 移动端预览 */}
          <div className="mobile-preview">
            <div className="phone-frame">
              <div className="phone-header">
                <div className="status-bar">
                  <span>.....</span>
                  <span>1:21 AM</span>
                  <span>100%</span>
                </div>
                <div className="nav-bar">
                  <span className="nav-spacer"></span>
                  <input 
                    type="text"
                    className="title-input"
                    value={activityConfig.title}
                    onChange={(e) => updateConfig('title', e.target.value)}
                    placeholder="请输入活动标题"
                  />
                  <div className="nav-buttons">
                    <span className="menu-btn">...</span>
                  </div>
                </div>
              </div>
              
              <div className="phone-content" 
                style={{ 
                  position: 'relative',
                  backgroundImage: activityConfig.backgroundImage.show && activityConfig.backgroundImage.image 
                    ? `url(${activityConfig.backgroundImage.image})` 
                    : 'none',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat'
                }}
                onMouseMove={(e) => {
                  if (isDraggingTheme) {
                    e.preventDefault();
                    const parentRect = e.currentTarget.getBoundingClientRect();
                    const themeImg = e.currentTarget.querySelector('.theme-image');
                    if (themeImg) {
                      const newX = e.clientX - parentRect.left - dragStart.x;
                      const newY = e.clientY - parentRect.top - dragStart.y;
                      setActivityConfig(prev => ({
                        ...prev,
                        lotteryTheme: {
                          ...prev.lotteryTheme,
                          titlePosition: {
                            x: newX,
                            y: newY
                          }
                        }
                      }));
                    }
                  }
                }}
                onMouseUp={() => setIsDraggingTheme(false)}
                onMouseLeave={() => setIsDraggingTheme(false)}
              >
                <div className="lottery-preview">
                  {/* 抽奖主题图片 - 可拖动 */}
                  {activityConfig.lotteryTheme.titleImage && (
                    <div
                      className="theme-image"
                      style={{
                        position: 'absolute',
                        left: `${activityConfig.lotteryTheme.titlePosition.x}px`,
                        top: `${activityConfig.lotteryTheme.titlePosition.y}px`,
                        cursor: isDraggingTheme ? 'grabbing' : 'grab',
                        zIndex: 10,
                        userSelect: 'none'
                      }}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setIsDraggingTheme(true);
                        const rect = e.currentTarget.getBoundingClientRect();
                        const parentRect = e.currentTarget.parentElement.parentElement.getBoundingClientRect();
                        setDragStart({
                          x: e.clientX - rect.left,
                          y: e.clientY - rect.top
                        });
                      }}
                    >
                      <img
                        src={activityConfig.lotteryTheme.titleImage}
                        alt="抽奖主题"
                        style={{ width: 'auto', height: 'auto', display: 'block', pointerEvents: 'none' }}
                        draggable={false}
                      />
                    </div>
                  )}
                  {!activityConfig.lotteryTheme.titleImage && (
                  <div className="lottery-title">幸运大抽奖</div>
                  )}
                  {/* 转盘部分 */}
                  <div style={{ position: 'relative', width: '100%', maxWidth: '320px', marginTop: '90px', marginBottom: '20px', marginLeft: 'auto', marginRight: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img
                      ref={wheelImageRef}
                      src={activityConfig.wheel.wheelImage || rouletteImage}
                      alt="转盘底座"
                      style={{
                        width: '100%',
                        display: 'block',
                        pointerEvents: 'none'
                      }}
                    />
                    {renderDividerLines(wheelImageSize)}
                    {renderPrizeOverlayElements(wheelImageSize)}
                    <div
                      style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 5
                      }}
                    >
                      {activityConfig.wheel.startButton ? (
                        <img
                          src={activityConfig.wheel.startButton}
                          alt="开始按钮"
                          style={{
                            width: `${(wheelImageSize || 280) * 0.3}px`,
                            height: 'auto',
                            display: 'block'
                          }}
                        />
                      ) : (
                        <img
                          src={pointerImage}
                          alt="默认开始按钮"
                          style={{
                            width: `${(wheelImageSize || 280) * 0.3}px`,
                            height: 'auto',
                            display: 'block'
                          }}
                        />
                      )}
                    </div>
                  </div>
                  <div className="lottery-info">
                    <p>已有{participantCount}人参与</p>
                    {(() => {
                      const totalUnlimited = activityConfig.distributionMethod.totalDrawChances === 'unlimited';
                      const dailyUnlimited = activityConfig.distributionMethod.dailyDrawChances === 'unlimited';
                      const totalLimit = activityConfig.distributionMethod.totalDrawLimit || 0;
                      const dailyLimit = activityConfig.distributionMethod.dailyDrawLimit || 3;

                      // 情况1: 总抽奖机会不限 + 每日抽奖限制 → 显示"您今天还有 x次抽奖机会"
                      if (totalUnlimited && !dailyUnlimited) {
                        return (
                          <p>您今天还有{dailyLimit}次抽奖机会</p>
                        );
                      }
                      
                      // 情况2: 总抽奖机会限制 + 每日抽奖不限 → 显示"您还有 x次抽奖机会"
                      if (!totalUnlimited && dailyUnlimited) {
                        return (
                          <p>您还有{totalLimit}次抽奖机会</p>
                        );
                      }
                      
                      // 情况3: 都限制 → 显示"您今天还有 x次抽奖机会" 和 "剩余 x 次抽奖机会"
                      if (!totalUnlimited && !dailyUnlimited) {
                        return (
                          <>
                            <p>您今天还有{dailyLimit}次抽奖机会</p>
                            <p>剩余{totalLimit}次抽奖机会</p>
                          </>
                        );
                      }
                      
                      // 情况4: 都不限制 → 显示默认文本
                      return (
                        <p>您今天还有不限次抽奖机会</p>
                      );
                    })()}
                  </div>
                  
                  {/* 奖品说明 */}
                  <div style={{ 
                    background: 'white', 
                    borderRadius: '8px', 
                    padding: '16px', 
                    margin: '16px 0',
                    marginTop: '16px',
                    marginBottom: '16px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    width: '100%',
                    boxSizing: 'border-box'
                  }}>
                    {/* 活动说明 */}
                    <div style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      marginBottom: '12px',
                      fontSize: '16px',
                      fontWeight: 600,
                      color: '#333'
                    }}>
                      <span style={{ marginRight: '8px', fontSize: '18px' }}>📋</span>
                      <span>活动说明</span>
                    </div>
                    
                    {/* 活动时间 */}
                    <div style={{
                      marginBottom: '16px',
                      padding: '12px',
                      background: '#f8f8f8',
                      borderRadius: '6px',
                      fontSize: '14px',
                      color: '#666',
                      lineHeight: '1.5'
                    }}>
                      <div style={{ marginBottom: '4px', fontWeight: 500, color: '#333' }}>
                        活动时间：
                      </div>
                      <div>
                        {(() => {
                          // 格式化日期，只显示年月日部分
                          const formatDate = (dateTimeStr) => {
                            if (!dateTimeStr) return '';
                            // 提取日期部分（YYYY-MM-DD）
                            return dateTimeStr.split(' ')[0] || dateTimeStr;
                          };
                          return `${formatDate(activityConfig.startTime)} 至 ${formatDate(activityConfig.endTime)}`;
                        })()}
                      </div>
                    </div>
                    
                    {/* 活动奖品 */}
                    <div style={{ marginTop: '16px' }}>
                      <div style={{ 
                        fontSize: '15px', 
                        fontWeight: 'normal', 
                        color: '#333',
                        marginBottom: '12px'
                      }}>
                        活动奖品
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        {activityConfig.prizes
                          .filter((prize) => !prize.isEmptyPrize) // 过滤掉"谢谢参与"
                          .map((prize, index, filteredArray) => {
                            const displayName = prize.name || prize.level || `奖项${index + 1}`;
                            const isLast = index === filteredArray.length - 1;
                            return (
                              <div 
                                key={prize._duplicateId || prize.id || `prize-desc-${index}`}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  paddingBottom: '12px',
                                  borderBottom: !isLast ? '1px solid #f0f0f0' : 'none'
                                }}
                              >
                              <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '8px',
                                background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '24px',
                                marginRight: '12px',
                                boxShadow: '0 2px 6px rgba(255,215,0,0.3)'
                              }}>
                                {prize.image ? (
                                  <img 
                                    src={prize.image} 
                                    alt={displayName}
                                    style={{ 
                                      width: '100%', 
                                      height: '100%', 
                                      objectFit: 'cover',
                                      borderRadius: '8px'
                                    }}
                                  />
                                ) : (
                                  <span>🎁</span>
                                )}
                              </div>
                              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                {/* 第一行：奖品等级或名称，加粗 */}
                                <div style={{ 
                                  fontSize: '15px', 
                                  fontWeight: 600, 
                                  color: '#333',
                                  marginBottom: '4px',
                                  lineHeight: '1.4'
                                }}>
                                  {prize.level || prize.name || displayName}
                                </div>
                                {/* 第二行：奖品名称或描述 */}
                                {(prize.name || prize.description) && (
                                  <div style={{ 
                                    fontSize: '13px', 
                                    fontWeight: 'normal', 
                                    color: '#999',
                                    lineHeight: '1.3'
                                  }}>
                                    {prize.description || prize.name}
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>

          {/* 配置面板 */}
          {renderConfigPanel()}
        </div>
      </div>
    </div>
    </>
  );
};

export default LotteryActivityManager;
